module.exports = __webpack_public_path__ + "static/logos/icon-linkedin-7f8557ee41ae5ced1e327f14f9fe1f02.svg";